import { render, staticRenderFns } from "./Blade3.vue?vue&type=template&id=54a2c042&scoped=true&"
import script from "./Blade3.vue?vue&type=script&lang=ts&"
export * from "./Blade3.vue?vue&type=script&lang=ts&"
import style0 from "./Blade3.vue?vue&type=style&index=0&id=54a2c042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2c042",
  null
  
)

export default component.exports